import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-qavisitentry",
  templateUrl: "./qavisitentry.component.html",
  styleUrls: ["./qavisitentry.component.scss"],
})
export class QavisitentryComponent implements OnInit {
  title: string = "تسجيل تقارير الجودة";
  constructor() {}

  ngOnInit() {}
}
